<template>
  <div class="landing-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="" style="text-align: center">
            <img style="width: 35%;margin-top: 50px" src="../../static/images/logo.png">
          </div>
          <div class="middle">
            <img src="../../static/images/login_pic1.png">
          </div>
          <div class="login-tip">
            <span>{{ $t('loginTips') }}</span>
          </div>
          <div class="login-overlay">
            <div class="input-div">
              <div class="input-item mt20"
                   style="background: rgba(255, 255, 255, 0.85);">
                <div class="input-item2">
                  <span class="app-en">
                    <img style="vertical-align: middle;" src="../../static/images/input_09.png">
                  </span>
                  <input class="input" style="color: black" v-model="mobile" type="text"
                         maxlength="15"
                         inputmode="numeric"
                         pattern="[0-9]*">
                </div>
              </div>
            </div>
            <div class="ac mt30 por">
              <div class="login-list" :class="{'single-button': isSingleButton}">
                <div class="drown-li" v-if="showDaily" @click="getType('daily')">
                  <div class="disflex day por day-en">
                    <div class="btn-text">{{ $t('Daily') }}</div>
                  </div>
                </div>
                <div class="drown-li" v-if="showWeekly" @click="getType('weekly')">
                  <div class="disflex month por month-en">
                    <div class="btn-text">{{ $t('Weekly') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ac otp-b disflex por login-footer">
            <div class="icon icon2 login_help" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
            <div class="icon icon2 login_help" @click="getChange('faq')">{{ $t('FAQ') }}</div>
          </div>
        </div>
      </div>
    </div>
    <Dialog ref="resubDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal ac" slot="mdBox">
        <div class="close" @click="closeTmgDialog"
             style="text-align: right;margin:10px auto;font-size: 50px;margin-right: -20px;">
          <img width="70" src="../../static/images/close.png"/>
        </div>
        <div class="fs33 mt50 ac">{{ $t('re_sub_tip') }}</div>
        <button class="button mt30" @click="goLogin()">{{ $t('subscribe') }}</button>
        <button class="button mt30" @click="login()">{{ $t('Login') }}</button>
      </div>
    </Dialog>
  </div>
</template>
<script>

import Dialog from "../components/dialog.vue";
import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {
    Dialog,

  },
  data() {
    return {
      isEN: "bur",
      list: [],
      mobile: '',
      password: '',
      type: 'weekly',
      showDaily: true,  // 控制 daily 的显示
      showWeekly: true,  // 控制 weekly 的显示
      //land 配置
      foc_free_land_tip: '',
      foc_daily_free: 0,
      foc_week_free: 0,
      foc_status: 0,
    }
  },
  computed: {
    // 仅显示一个订阅按钮时：不要被 flex 撑满整行
    isSingleButton() {
      return (this.showDaily && !this.showWeekly) || (!this.showDaily && this.showWeekly);
    }
  },
  created() {
    this.getLandConfig();
    if (localStorage.getItem('lang')) {
      this.isEN = localStorage.getItem('lang');
    }
    if (this.$route.query.msidn) {
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
    }
    var type = this.$route.query.type
    if (type === 'day') {
      this.showDaily = true
      this.showWeekly = false
    } else if (type === 'week') {
      this.showWeekly = true
      this.showDaily = false
    } else {
      this.showDaily = true
      this.showWeekly = true
    }

  },
  methods: {
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    getType(type) {
      this.type = type
      this.userStatus()
    },
    back() {
      this.$router.go(-1);
    },
    userStatus() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      const userAgent = navigator.userAgent;
      const deviceId = this.getDeviceId();
      let data = {
        mobile: mobile,
        user_agent: userAgent,
        device_id: deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80);
          } else {
            if (r.data.status == 1 || r.data.status == -2) {
              if (r.data.change_device) {
                that.goOtpLogin();
                return;
              } else {
                that.login();
                return;
              }
            }
            if (r.data.status == 3 && r.data.valid == 'Y') {
              that.$refs.resubDialog.showMaskFun();
            } else {
              that.goAtomCg();
            }
          }
        })
      })

    },
    goOtpLogin() {
      let that = this
      let mobile = that.getMobile();
      let encryptedMobile = that.aesEcbEncrypt(mobile);
      this.$router.push({path: '/otp', query: {msidn: encryptedMobile}});
    },
    goAtomCg() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      let type = this.type
      that.$parent.loadModal(true);
      let params = new URLSearchParams(this.$route.query);
      // 移除重复项
      params.delete('mobile');
      params.delete('subappid');
      // 添加新参数
      params.set('mobile', mobile);
      params.set('subappid', type);

      let url = '/api/user/get_cg_url?' + params.toString();
      that.$api.get(url, {}, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          window.location.href = r.data + "&reg=reg";
        } else {
          that.$utils.alertText(r.msg, 80);
        }
      })
    },
    goMytelSub(){
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      let type  = this.type
      delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
      delete queryParams.type; // 删除 type，避免 URL 里重复
      let queryString = Object.keys(queryParams).length
        ? '&' + Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
        : '';
      that.$parent.loadModal(true);
      let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          if (r.code == 1){
            let encryptedMobile = that.aesEcbEncrypt(mobile);
            window.location.href = "https://arrows.ongames.asia?msidn=" + encodeURIComponent(encryptedMobile);
          }else{
            that.$parent.loadModal(false);
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    login() {
      let that = this;
      if (that.mobile === "") {
        that.$utils.alertText(that.$t('phone_error'), 80)
        return
      }
      let mobile = that.getMobile();
      let encryptedMobile = that.aesEcbEncrypt(mobile);
      that.$parent.loadModal(true);
      window.location.href = "https://arrows.ongames.asia?msidn=" + encodeURIComponent(encryptedMobile);
    },
    getLandConfig() {
      let that = this
      let url = '/api/land/config'
      that.$api.get(url, {}, r => {
        if (r.code == 1) {
          that.background_image = r.data.back_image
          that.foc_free_land_tip = r.data.free_land_tip
          that.foc_daily_free = r.data.daily_free
          that.foc_week_free = r.data.week_free
          that.foc_status = r.data.status
        }
      })
    },
    getMobile(){
      let mobile = '09' + this.mobile
      mobile = this.dealPhone(mobile)
      return mobile;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('96') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    closeTmgDialog() {
      this.$refs.resubDialog.closeMask();
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    //加密
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm"); // 16字节密钥
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);

      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    //解密
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {

        return "";
      }
    },
  }
}
</script>
<style scoped>
.landing-page {
  min-height: 100vh;
  background-size: cover !important;
}

.otp-b {
  justify-content: space-evenly;
}

.login-overlay {
  z-index: 10;
}

.login-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 14px;
  max-width: 520px;
  margin: 0 auto;
}

/* 只显示一个按钮：保持单个按钮宽度，不要 flex 撑满整行 */
.login-list.single-button {
  justify-content: center;
  gap: 0;
  max-width: none;
}

.login-list.single-button .drown-li {
  flex: 0 0 auto;
  width: min(260px, 80vw);
}

.login-list .drown-li {
  flex: 1;
  margin: 0;
  width: auto;
}

/* 按钮公共基础样式（使用 daily/week 背景图） */
.login-list .disflex {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 92px;
  border-radius: 24px;
  background-size: 100% 100% !important;
}

.middle img {
  top: 300px !important;
  width: 520px !important;
  max-width: 90% !important;
}


/* 输入框 placeholder 样式更接近截图 */
.input-div input.input::placeholder {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* 输入框：压缩高度与宽度，避免过长过高 */
.input-div .input-item {
  width: 86% !important;
  height: 76px !important;
  border-radius: 60px !important;
  margin: 0 auto !important;
}

.input-div .input-item2 {
  height: 76px !important;
  border-radius: 60px !important;
}

.input-div .app-en {
  padding: 0 !important;
  margin-right: 10px;
}

.input-div .app-en img {
  width: 120px !important;
  height: auto;
  display: inline-block;
}

.input-div input.input {
  height: 76px !important;
  line-height: 76px !important;
  font-size: 42px !important;
  font-weight: 700 !important;
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
}

/* 底部 TC / FAQ：比原来 mt100 略靠上 */
.login-footer {
  margin-top: 270px !important;
}

.day-en {
  background: url(../../static/images/daily-bg_en.png) no-repeat center !important;
  background-size: 100% 100% !important;
}



.month-en {
  background: url(../../static/images/week-bg_en.png) no-repeat center !important;
  background-size: 100% 100% !important;
}


</style>



// WEBPACK FOOTER //
// src/page/Login.vue